import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { AllowedReducer } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import RenewTemporaryUsersDialog from "../components/RenewTemporaryUserDialog.js";
const {
  t,
  tf
} = I18N.ns('temporaryUserManagement.action.Renew');
export default {
  id: 'temporaryUserManagement.action.Renew',
  type: 'ResourceTemporaryUsers.renew',
  name: tf('name'),
  layout: {
    sort: 'renew'
  },
  matches: {
    use: 'contextMenu',
    client: 'ResourceTemporaryUsers'
  },
  appearance: opts => {
    const {
      context
    } = opts;
    const user = Context.getTargetOfType(context, 'temporaryUser');
    const disabled = user == null;
    const name = t('appearanceName', {});
    return {
      name,
      disabled,
      visible: true
    };
  },
  prepare: async context => {
    const {
      clientProps: {
        actions,
        dispatch
      }
    } = context;
    const user = Context.getTargetOfType(context, 'temporaryUser');
    if (user == null) {
      return null;
    }
    const allowed = AllowedReducer.get(GlobalState.get(), typeof user === 'string' ? user : user.username);
    if (typeof allowed.renewTemporaryUser !== 'boolean') {
      return dispatch(actions.temporaryUser(user).canRenew());
    }
    return null;
  },
  isPrepared: context => {
    const user = Context.getTargetOfType(context, 'temporaryUser');
    if (user == null) {
      return true;
    }
    const allowed = AllowedReducer.get(GlobalState.get(), typeof user === 'string' ? user : user.username);
    return typeof allowed?.renewTemporaryUser === 'boolean';
  },
  handles: context => {
    const user = Context.getTargetOfType(context, 'temporaryUser');
    if (user == null) {
      return false;
    }
    const obj = typeof user === 'string' ? context.clientProps?.users?.find(u => u.username === user) : user;
    if (obj.revokedAt != null) {
      return false;
    }
    const allowed = AllowedReducer.get(GlobalState.get(), typeof user === 'string' ? user : user.username);
    return allowed?.renewTemporaryUser === true;
  },
  perform: ({
    context
  }) => {
    const user = Context.getTargetOfType(context, 'temporaryUser');
    const {
      actions,
      api,
      emailOptions,
      smsOptions,
      uiName,
      uiUrl
    } = context;
    Dialogs.show({
      component: RenewTemporaryUsersDialog,
      props: {
        user,
        actions,
        api,
        emailOptions,
        smsOptions,
        uiName,
        uiUrl
      }
    });
  }
};